<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo">{{ title }}</h2>
        <div class="mural" v-if="showContent">
          <div class="content">
            <div class="numero_mensagens">{{ items.length }} mensagens</div>
            <div class="comentario" v-for="item in items">
              <div class="avatar">
                {{ item.avatar }}
              </div>
              <span>{{ item.name }}</span>
              <p>{{ item.comment }}</p>
              <div class="resposta" v-if="item.answers" v-for="answer in item.answers">
                <div class="avatar">{{ answer.avatar }}</div>
                <span>{{ answer.name }}</span>
                <p>{{ answer.comment }}</p>
              </div>
            </div>
          </div>
          <div class="peca_musica" id="contato">
            <span>Deixe sua mensagem</span>
            <form>
              <div class="errorContent" v-show="checkShowErrorMessage()">
                <div v-html="errorMessage"></div>
              </div>
              <div class="row successContent" v-show="checkShowSuccessMessage()">
                <div class="col col-md-12">
                  <div v-html="successMessage"></div>
                </div>
              </div>
              <label>
                Nome:
                <input type="text" v-model="name">
              </label>
              <label>
                Email:
                <input type="text" v-model="email">
              </label>
              <label>
                Estado:
                <input type="text" v-model="state">
              </label>
              <label>
                Cidade:
                <input type="text" v-model="city">
              </label>
              <label class="mensagem">
                Mensagem:
                <textarea v-model="message"></textarea>
              </label>

              <vue-recaptcha ref="recaptcha"  @verify="onVerify" @expired="onExpired" :sitekey="sitekey" class="captcha">
              </vue-recaptcha>

              <button class="btn_enviar" type="button" @click="callback()"> Enviar </button>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import {get, post} from '../../helpers/api';
  import Loading from '../common/Loading.vue';
  import VueRecaptcha from 'vue-recaptcha';

  let RECAPTCHA_KEY = window.config.RECAPTCHA_KEY;

  export default {
    components: {
      Loading,
      VueRecaptcha
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Mural de recados',
        showContent: true,
        items: [],
        name: '',
        email: '',
        city: '',
        state: '',
        message: '',
        errorMessage: '',
        successMessage: '',
        sitekey: window.config.RECAPTCHA_KEY,
        captcha: false
      }
    },
    created() {
      this.recaptchaKey = RECAPTCHA_KEY;
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      // get('content/' + this.bloco.id).then(function (response) {

        let messages = this.$store.getters['getSiteContent'].result.data.recado;
        // let messages = response.data.result.data;
        messages.forEach(function (message) {
          let answers = [];
          if (typeof message.answers !== 'undefined') {
            answers.push({
              avatar: message.answers.avatar,
              name: 'Admin',
              comment: message.answers.comment
            })
          }

          self.items.push({
            avatar: message.name.substring(0, 1).toUpperCase(),
            name: message.name,
            comment: message.comment,
            answers: answers
          });
        });
      // });
    },
    methods: {
      onSubmit: function () {
        this.$refs.recaptcha.execute();
      },
      onVerify: function (response) {
        this.captcha = response;
      },
      onExpired: function () {
      },
      resetRecaptcha() {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      checkShowErrorMessage() {
        return this.errorMessage !== '';
      },
      checkShowSuccessMessage() {
        return this.successMessage !== '';
      },
      clearForm() {
        this.name = '';
        this.email = '';
        this.city = '';
        this.state = '';
        this.message = '';
      },
      callback() {
        // google recaptcha token , then you can pass to backend with your form data .
        if (!this.name) {
          alert('O campo nome é obrigatório.');
          return false;
        }
        if (!this.message) {
          alert('O campo mensagem é obrigatório.');
          return false;
        }
        if (!this.email) {
          alert('O campo email é obrigatório.');
          return false;
        }
        if (!this.captcha) {
          alert('Favor marcar captcha.');
          return false;
        }

        this.showContent = false;
        let self = this;
        post('message-board', {
          name: this.name,
          email: this.email,
          city: this.city,
          state: this.state,
          message: this.message
        }).then(function () {
          self.showContent = true;
          swal.fire({
            title: "Mensagem enviada com sucesso.",
            icon: "success",
          });
          self.clearForm();
        }).catch(function (response) {
          self.showContent = true;
          swal.fire({
            title: "Ocorreu um erro ao enviar a mensagem, tente novamente mais tarde.",
            icon: "error",
          });
        });
      },
    },
    watch: {
      name(name) {
        if (this.errorMessage !== '' && name.length > 0) {
          this.errorMessage = '';
        }
      },
      message(message) {
        if (this.errorMessage !== '' && message.length > 0) {
          this.errorMessage = '';
        }
      },
      email(email) {
        if (this.errorMessage !== '' && email.length > 0) {
          this.errorMessage = '';
        }
      },
      successMessage(message) {
        if (message.length > 0) {
          let self = this;
          setTimeout(function () {
            self.successMessage = '';
          }, 5000);
        }
      },
      errorMessage(message) {
        // if (message.length > 0) {
        //   let self = this;
        //   setTimeout(function () {
        //     self.errorMessage = '';
        //   }, 45000);
        // }
      }
    }
  }
</script>
<style>
  .errorContent {
    padding: 5px;
    height: 100%;
    width: 100%;
    background-color: red;
    color: white;
  }

  .successContent {
    height: 100%;
    width: 100%;
    background-color: green;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/MessageBoards.vue